import React, { useState } from "react";
import { useHistory } from "react-router-dom";

import {
  Button,
  Typography,
  Grid,
  CircularProgress,
  TextField,
} from "@mui/material";

import { useMediaQuery, useTheme } from "@mui/material";

import { useSnackbar } from "notistack";

import Logo from "@assets/images/logo.png";

import { API } from "@services/API";

export default function Verify({ ...props }) {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("md"));

  const history = useHistory();

  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  const [loading, setLoading] = useState(false);

  const [email, setEmail] = useState(localStorage.getItem("email"));
  const [code, setCode] = useState("");

  const showSnackBar = (type, title, subtitle) => {
    const options = { variant: type };

    enqueueSnackbar(
      <div style={{ display: "inline-grid" }}>
        <Typography variant="h6">{title}</Typography>
        <Typography variant="subtitle1">{subtitle}</Typography>
      </div>,
      options
    );
  };

  const isNullOrEmpty = (value) => {
    if (value === null || value === undefined) {
      return true;
    }

    if (typeof value === "string" && value.trim().toLowerCase() === "null") {
      return true;
    }

    if (Array.isArray(value) && value.length === 0) {
      return true;
    }

    if (typeof value === "string" && value.trim() === "") {
      return true;
    }

    if (typeof value === "number" && isNaN(value)) {
      return true;
    }

    return false;
  };

  const isValidEmail = (email) => {
    if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email)) {
      return true;
    } else {
      return false;
    }
  };

  const handleVerify = (event) => {
    event.preventDefault();

    if (isNullOrEmpty(email)) {
      showSnackBar("error", "Failure", "Email can't be empty.");
    } else if (!isValidEmail(email)) {
      showSnackBar("error", "Failure", "Invalid email address.");
    } else if (isNullOrEmpty(code)) {
      showSnackBar("error", "Failure", "Code can't be empty.");
    } else {
      setLoading(true);

      API.post(`/user/verify`, {
        UserName: email.trim(),
        Code: code.trim(),
      })
        .then((response) => {
          localStorage.setItem("covid19_token", response.data.token);
          localStorage.setItem("user_id", response.data.user_id);
          localStorage.setItem("user_level", response.data.level);
          localStorage.setItem("user_facility_id", response.data.facility_id);

          history.push("/login");
        })
        .catch((error) => {
          setLoading(false);
          showSnackBar("error", "Failure", "Internal server error.");
        });
    }
  };

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "85vh",
      }}
    >
      <Grid
        container
        spacing={2}
        style={{ width: isSmallScreen ? "90%" : "500px" }}
      >
        <Grid
          item
          xs={12}
          style={{ display: "flex", justifyContent: "center" }}
        >
          <img src={Logo} alt="logo" height="100px" />
        </Grid>

        <Grid
          item
          xs={12}
          style={{ display: "flex", justifyContent: "center" }}
        >
          <Typography
            variant="h3"
            color={"primary"}
            style={{ fontWeight: "bold" }}
          >
            Administration Portal
          </Typography>
        </Grid>

        <Grid item xs={12}>
          <Typography>
            Either your password was incorrect or you need to verify your email.
          </Typography>
        </Grid>

        <Grid item xs={12}>
          <Typography>
            Enter in the verification code sent to your email address, to verify
            your account (this only needs to be done for initial Login)
          </Typography>
        </Grid>

        <Grid item xs={12}>
          <TextField
            variant="outlined"
            id="email"
            label="Email"
            type="email"
            onChange={(e) => setEmail(e.target.value)}
            value={email}
            autoFocus={true}
            required={true}
            fullWidth
          />
        </Grid>

        <Grid item xs={12}>
          <TextField
            variant="outlined"
            id="code"
            label="Code"
            onChange={(e) => setCode(e.target.value)}
            value={code}
            autoFocus={true}
            required={true}
            fullWidth
          />
        </Grid>

        <Grid item xs={12}>
          <Typography>
            Re-enter your Password ? <a href="/login">Back to login screen</a>
          </Typography>
        </Grid>

        <Grid item xs={12}>
          <Button
            variant="contained"
            type={"submit"}
            size={"large"}
            loading={loading}
            disabled={loading}
            onClick={handleVerify}
            fullWidth
          >
            {loading ? (
              <CircularProgress size={24} color="inherit" />
            ) : (
              "Verify Code and Proceed"
            )}
          </Button>
        </Grid>
      </Grid>
    </div>
  );
}
